import { RootState } from "store/reducers/main";
import { FeatureFlagsEnum } from "types/working-model";

export const selectFeatureFlag = (flag: FeatureFlagsEnum) =>
	(state: RootState) => state.FeatureFlagsReducer.featureFlags[flag];

export const selectUseConfirmationUrls = selectFeatureFlag(FeatureFlagsEnum.integrations_confirmation_urls);

export const selectUseSsoAttrMapping = selectFeatureFlag(FeatureFlagsEnum.sso_attr_mapping_2025);
export const selectEditorNavV3 = (state: RootState) => {
	if (import.meta.env.VITE_STAGE === 'local' && localStorage.getItem('force-v3')) {
		return true;
	}

	const userChannelType = state.AuthReducer.userChannelType;
	if (!userChannelType || userChannelType === 'unset') {
		return false;
	}

	return true;
};
export const selectUiAiCaptions = selectFeatureFlag(FeatureFlagsEnum.ui_ai_captions);
export const selectProjectTitleSync = selectFeatureFlag(FeatureFlagsEnum.project_title_sync);
export const selectModeratorClaimsFeatureFlag = selectFeatureFlag(FeatureFlagsEnum.moderator_claims);
export const selectAudiencesV2 = selectFeatureFlag(FeatureFlagsEnum.audience_list_members);
export const selectEnableTicketing = selectFeatureFlag(FeatureFlagsEnum.enable_ticketing);
export const selectInPersonAutoFill = selectFeatureFlag(FeatureFlagsEnum.in_person_auto_fill);
